export default __webpack_public_path__ + "static/media/upload.e4b23a12.svg";